import { AvailabilityRulesState } from './partials/availability-rules'
import { AvailabilitySlotsState } from './partials/availability-slots'
import { LinkedCalendarsState } from './partials/linked-calendars'
import { PermissionState } from './partials/permissions'
import { SchedulingAssistantState } from './partials/scheduling-assistant'

import moment from 'moment-timezone'

export const CalendarState = _ => ({
  ...PermissionState,
  ...AvailabilityRulesState,
  ...AvailabilitySlotsState,
  ...LinkedCalendarsState,
  ...SchedulingAssistantState,

  abortControllers: {
    fetchCalendarEvents: null,
    getCalendarGlanceItems: null,
  },

  appointmentTypes: [],
  actionsRunning: 0,
  runningRequests: 0,

  selectedCalendar: {
    availabilitySlots: [],
    date: new Date(),
    events: [],
    eventsCount: [],
    timezone: moment.tz.guess(true),
    userId: undefined,
  },

  sharedCalendars: [],

  timezones: {
    main: [],
    other: [],
  },
})
